<div class="p-6 flex flex-col items-center text-center max-w-sm mx-auto">
  <div class="text-5xl mb-4">🎁</div>

  <h3 class="text-xl font-bold text-site mb-3 leading-snug">
    {{ data.promotion.title }}
  </h3>

  <div class="bg-green-50 border border-green-200 rounded-xl px-5 py-4 mb-5 w-full">
    <p class="text-green-700 font-semibold text-base">{{ getDiscountText() }}</p>
  </div>

  <div class="text-gray-500 text-sm">
    <!-- Cas 1 : Tout montant (0€ à 9999€) -->
    @if (data.rule.min === 0 && data.rule.max === 9999) {
      <span>
        Valable pour <strong>tout montant</strong> de commande.
      </span>
    }

    <!-- Cas 2 : À partir d'un montant minimum sans limite max réelle (ex: min: 20, max: 9999) -->
    @if (data.rule.min !== 0 && data.rule.max === 9999) {
      <span>
        Valable pour une commande <strong>au-delà de {{ data.rule.min | number:'1.2-2' }} €</strong>
      </span>
    }

    <!-- Cas 3 : Intervalle précis entre deux montants (ex: min: 15, max: 50) -->
    @if (data.rule.min !== 0 && data.rule.max !== 9999) {
      <span>
        Valable pour une commande de
        <strong>{{ data.rule.min | number:'1.2-2' }} €</strong> à
        <strong>{{ data.rule.max | number:'1.2-2' }} €</strong>
      </span>
    }
  </div>
  <div class="mt-3 text-center text-gray-600 text-sm mb-3">
    💰 Total après réduction :
    <span class="font-bold text-lg">{{ getDiscountedTotal() | number:'1.2-2' }}€</span>
  </div>
  <div class="mt-2 text-xs text-gray-500 bg-blue-50 border border-blue-200 rounded-lg p-2.5 w-full mb-4">
    ℹ️ <em>Ce montant inclut uniquement le prix de vos produits. Les frais de livraison et de commande éventuels seront ajoutés au total final.</em>
  </div>
  <button
    [matButton]="themeConfig.appearance.button.action"
    (click)="close()"
    class="w-full ">
    D'accord, super ! 👍
  </button>
</div>
